import { useSearchParams } from 'react-router-dom'
import { SignupSuccessPanel } from './SignupSuccessPanel'

export const SignupSuccess = () => {
  const [searchParams] = useSearchParams()
  const orgId = searchParams.get('org_id')

  return <SignupSuccessPanel orgId={orgId} variant="page" />
}
